import { useState, useCallback } from 'react';
import * as Sentry from '@sentry/browser';

import { getFeatureList } from '@/services/common';
import type { CommonModule } from '@/services/common/typings';
import { getMccBelongGrayscale } from '@/services/accounts/google';
import { getVaGrayscale } from '@/services/offlinepayment/index';
import type { OfflinePaymentAPI } from '@/services/offlinepayment/interface';

export type Feature = CommonModule.Common.Feature & OfflinePaymentAPI.Response.Grayscale;

export default function useFeatureGrayModel() {
  const [loading, setLoading] = useState(false); // 是否加载中
  const [feature, setFeature] = useState<Feature>({}); // 灰度列表

  // gg-mcc 灰度
  const [mccBelongLoading, setMccBelongLoading] = useState(false);
  const [mccBelongGraysca, setMccBelongGrayscale] = useState<boolean>(false);

  // hsva 灰度
  const [hsVaLoading, setHsVaLoading] = useState(false);
  const [hsVaGrayscale, setHsVaGrayscale] = useState<boolean>(false);

  /** 获取灰度列表 */
  const fetchFeatureData = useCallback(async () => {
    try {
      setLoading(true);
      // 灰度平台的第三方接口，因返回结构无法复用 bv-request，使用 axios 请求
      const [data, error] = await getFeatureList();

      if (error) {
        throw new Error(error);
      } else {
        setFeature(data || {});
      }
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      setLoading(false);
    }
  }, []);

  /** 获取 gg-mcc 灰度列表 */
  const getMccBelongGrayscaleInfo = useCallback(async () => {
    setMccBelongLoading(true);

    const [mccBelongInfo] = await getMccBelongGrayscale();

    if (mccBelongInfo) {
      setMccBelongGrayscale(mccBelongInfo.mccBelong);
    }

    setMccBelongLoading(false);
  }, []);

  /** 获取 hsva 灰度 */
  const getVaGrayscaleInfo = useCallback(async () => {
    setHsVaLoading(true);

    const [hsvaInfo] = await getVaGrayscale();

    if (hsvaInfo) {
      // 更新灰度信息中关于 hsva 的字段
      setFeature((prevFeature) => {
        return { ...prevFeature, hsva: hsvaInfo.hsva };
      });

      setHsVaGrayscale(hsvaInfo?.hsva ?? false);
    }

    setHsVaLoading(false);
  }, []);

  return {
    feature,
    loading,

    fetchFeatureData,

    mccBelongLoading,
    mccBelongGraysca,

    getMccBelongGrayscaleInfo,

    hsVaLoading,
    hsVaGrayscale,
    getVaGrayscaleInfo,
  };
}
